<header id="header" class="header light sticky-top">
    <div class="menu" id="onepagenav">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container">
                <a class="navbar-brand" [routerLink]="['/feed']">GoExpats</a>
                <button class="navbar-toggler" type="button" 
                    (click)="toggleMenu()"
                    [attr.aria-expanded]="!isCollapsed" 
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" [class.show]="!isCollapsed">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0" (click)="closeMenu()">
                        <li class="nav-item" [class.active]="isActive('feed')">
                            <a class="nav-link" [routerLink]="['/feed']">Feed</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('homesection')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="homesection">Business</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('about-us')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="about-us">About us</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('history')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="history">History</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('team')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="team">Team</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('testimonial')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="testimonial">Testimonial</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('services')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="services">Services</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('contact-us')">
                            <a class="nav-link" [routerLink]="['/business']" fragment="contact-us">Contact us</a>
                        </li>
                    </ul>
                    <form class="d-flex col-md-2">
                        <select class="form-select" 
                            aria-label="Select city" 
                            [(ngModel)]="currentCity"
                            [ngModelOptions]="{standalone: true}"
                            (change)="switchCity()"
                            name="city">
                            <option value="all">All Cities</option>
                            <option *ngFor="let city of cities" [value]="city.api">{{city.name}}</option>
                        </select>
                    </form>
                </div>
            </div>
        </nav>
    </div>
</header>
